import { Component } from '@angular/core';

@Component({
  selector: 'about',
  template: '<h1>About</h1>'
})

export class AboutComponent {}
